"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var _MetadataEntry_1 = require("./_MetadataEntry");
exports._UserMetadata = {
    type: "list",
    member: {
        shape: _MetadataEntry_1._MetadataEntry,
        locationName: "MetadataEntry"
    }
};
//# sourceMappingURL=_UserMetadata.js.map